import PropTypes from 'prop-types';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const PollOptionPropTypes = PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string,
  mediaId: PropTypes.string,
  count: PropTypes.number,
  rating: PropTypes.number
});
const PollPropTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  mediaId: PropTypes.string,
  settings: PropTypes.shape({
    multipleVotes: PropTypes.bool.isRequired,
    votesDisplay: PropTypes.bool.isRequired,
    votersDisplay: PropTypes.bool.isRequired,
    voteRole: PropTypes.string.isRequired,
    resultsVisibility: PropTypes.string.isRequired
  }).isRequired,
  options: PropTypes.arrayOf(PollOptionPropTypes).isRequired
};
const PollActionsPropTypes = {
  changePollTitle: PropTypes.func,
  changePollImage: PropTypes.func,
  updatePollOption: PropTypes.func,
  addOption: PropTypes.func,
  removeOption: PropTypes.func
};
const PollContextPropTypes = {
  poll: PropTypes.shape(__spreadValues(__spreadValues({}, PollPropTypes), PollActionsPropTypes))
};

export { PollActionsPropTypes, PollContextPropTypes, PollOptionPropTypes, PollPropTypes };
//# sourceMappingURL=types.js.map
